export default function (existingArray, items) {
  return (existingArray || [])
    .concat(items)
    .filter((v, i, a) => a.indexOf(v) === i);
}
